import React, { useState } from "react";
import * as styles from "../../css/CaseStudyDetails.module.css";
import CaseStudyDetailsBanner from "./components/CaseStudyDetailsBanner";
import RichTextRenderer from "../../../../utils/components/RichTextRenderer";
import Seo from "../../../../utils/components/seo";
import BlogInfo from "../../blogs/details/components/BlogInfo";
import RenderMedia from "../../../../components/Images";

const CaseDetails = ({ pageContext }) => {
  const { caseStudy } = pageContext || {};
  const { meta_description, meta_title } = caseStudy || {};

  const { DesktopvideoId, mobileVideoId } = caseStudy || {};

  return (
    <>
      <Seo
        title={meta_title || "case studies"}
        description={meta_description}
      />

      <div>
        <CaseStudyDetailsBanner caseStudy={caseStudy} styles={styles} />
        <div className={styles?.caseStudySingleContentWrap}>
          <div className={styles?.caseStudySingleContent}>
            <BlogInfo
              blogTitle={caseStudy?.caseStudyName}
              blog_category={"Case study"}
              styles={styles}
              PdfFile={caseStudy?.pdf?.PdfFile}
              className={`${styles?.caseStudySingleTopContent} desktop`}
            />
            <RichTextRenderer content={caseStudy?.content} styles={styles} />

            {/* <RenderMedia
              mediaName={"casestudysingleImg.jpg"}
              className={styles?.caseStudySingleImg}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseDetails;
